module.exports = __webpack_public_path__ + "static/media/anc15ru.dcab82ca.pdf";